import type { ITableCell } from "@library-elements/table";

type Border = "Top" | "Left" | "Right" | "Bottom";

export const copyTableCellBorders = (
  cellTo: ITableCell,
  borderTo: Border,
  cellSrc: ITableCell,
  borderSrc: Border = borderTo,
) => {
  cellTo[`border${borderTo}Color`] = cellSrc[`border${borderSrc}Color`];
  cellTo[`border${borderTo}Width`] = cellSrc[`border${borderSrc}Width`];
  cellTo[`border${borderTo}Style`] = cellSrc[`border${borderSrc}Style`];
};

export const copyManyTableCellBorders = (
  cellTo: ITableCell,
  cellSrc: ITableCell,
  borders: Border[],
) => {
  for (const borderTo of borders) {
    cellTo[`border${borderTo}Color`] = cellSrc[`border${borderTo}Color`];
    cellTo[`border${borderTo}Width`] = cellSrc[`border${borderTo}Width`];
    cellTo[`border${borderTo}Style`] = cellSrc[`border${borderTo}Style`];
  }
};
